import { format } from "date-fns";
import ja from "date-fns/locale/ja";

// TODO：リファクタリング
export default class DateUtil {

    static toLocaleDate = (date: any): string => {
        if(date != null) {
            const year = parseInt(date.substring(0, 4));
            const month = parseInt(date.substring(4, 6));
            const day = parseInt(date.substring(6, 8));
            const dateTmp = new Date(year, month - 1, day);

            return format(dateTmp, 'yyyy年MM月dd日 (E)', {locale: ja});
        }

        return ""
    }

    static hyphenToLocaleDate = (date: any): string => {
        if(date != null) {
            const year = parseInt(date.substring(0, 4));
            const month = parseInt(date.substring(5, 7));
            const day = parseInt(date.substring(8, 10));
            const dateTmp = new Date(year, month - 1, day);
    
            return format(dateTmp, 'yyyy年MM月dd日 (E)', {locale: ja});
        }

        return ""
    }

    static toLocaleYearMonth = (date: any): string => {
        if(date != null) {
            const year = parseInt(date.substring(0, 4));
            const month = parseInt(date.substring(4, 6));
            const dateTmp = new Date(year, month - 1);

            return format(dateTmp, 'yyyy年MM月', {locale: ja});
        }

        return ""
    }

    static unixtimeToLocaleDate1 = (unixtime: number): string => {
        const result = unixtime ? format(new Date(unixtime).getTime(), 'yyyy年MM月dd日(E) HH:mm:ss', {locale: ja}) : '';
        return result;
    }

    static unixtimeToLocaleDate2 = (unixtime: number): string => {
        const result = unixtime ? format(new Date(unixtime).getTime(), 'yyyyMMddHHmmss') : '';
        return result;
    }

}